import { render, staticRenderFns } from "./ShowAndUploadImg.vue?vue&type=template&id=5aab6ff9&scoped=true"
import script from "./ShowAndUploadImg.vue?vue&type=script&lang=js"
export * from "./ShowAndUploadImg.vue?vue&type=script&lang=js"
import style0 from "./ShowAndUploadImg.vue?vue&type=style&index=0&id=5aab6ff9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aab6ff9",
  null
  
)

export default component.exports